import * as React from 'react';
const FolderIcon = ({ size = 18, ...props }) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        strokeWidth={0}
        viewBox='32 96 448 320'
        height={size}
        width={size}
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        {
            /* <path
            d='M213.338 96H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144H256.006z'
            stroke='none'
        /> */
            <path
                d='M213.338 96H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144H256.006z'
                stroke='none'
            />
        }
    </svg>
);
export default FolderIcon;
